import { 
  BarChart3,
  Briefcase,
  Shield,
  Settings,
  History,
  MessageSquare,
  TrendingUp,
  Server,
  TestTube
} from "lucide-react";

export interface SidebarNavItem {
  title: string;
  icon: any;
  onClick: () => void;
}

// Factory function to create navigation items with proper handlers
export const createNavItems = (
  navigate: (path: string) => void,
  setShowOrderDialog: (show: boolean) => void
): SidebarNavItem[] => [
  {
    title: "Place Order",
    icon: TrendingUp,
    onClick: () => setShowOrderDialog(true)
  },
  {
    title: "Portfolio Overview",
    icon: Briefcase,
    onClick: () => navigate('/portfolio')
  },
  {
    title: "Chat History",
    icon: MessageSquare,
    onClick: () => navigate('/chat-history')
  },
  {
    title: "Market Analysis",
    icon: BarChart3,
    onClick: () => navigate('/market-analysis')
  },
  {
    title: "Backtest History",
    icon: TestTube,
    onClick: () => navigate('/backtest-history')
  },
  {
    title: "Trading History",
    icon: History,
    onClick: () => navigate('/trading-history')
  },
  {
    title: "Compliance",
    icon: Shield,
    onClick: () => navigate('/compliance')
  },
  {
    title: "VM Endpoint Tester",
    icon: Server,
    onClick: () => navigate('/vm-tester')
  },
  {
    title: "Settings",
    icon: Settings,
    onClick: () => navigate('/settings')
  }
]; 